import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import MainLayoutWrapper from '../components/MainLayoutWrapper';
//import BusinessEntity from '../pages/MasterData/BusinessEntity/group';
import Groups from '../pages/BusinessEntity/Groups/group';
import Company from '../pages/BusinessEntity/Company/company';
import TradingPartners from '../pages/MasterData/TradingPartners/tradingpartners';
import Users from '../pages/Administration/Users/User';
import Templates from '../pages/Templates/Templates/templates';
import AccountReceivable from '../pages/DocumentUpload/DocumentUpload/AccountReceivable/AccountReceivable';
import AccountPayable from '../pages/DocumentUpload/DocumentUpload/AccountPayable/AccountPayable'

//import StatusTrail from '../pages/DocumentUpload/DocumentUpload/AccountReceivable/StatusTrail';
import Upload from '../pages/DocumentUpload/DocumentUpload/AccountReceivable/Upload';
import UploadPayable from '../pages/DocumentUpload/DocumentUpload/AccountPayable/UploadPayable';
//import StatusTrail from '../pages/DocumentUpload/DocumentUpload/AccountPayable/StatusTrail';

import Dashboard from '../pages/Dashboard/Dashboard';
import Login from '../pages/Auth/Login/Login';
import ChangePassword from '../pages/Auth/Login/ChangePassword';
import ResetPassword from '../pages/Auth/Login/ResetPassword';
import FirstTimeResetPassword from '../pages/Auth/Login/FirstTimeResetPassword';

import RequireNoAuth from '../routes/component/RequireNoAuth';
import RequireJWT from '../routes/component/RequireJWT';
import RequireAuth from '../routes/component/RequireAuth';
import Profile from '../pages/Settings/Profile';
import CompanyProfile from '../pages/Settings/CompanyProfile';
import Contact from '../pages/Contact/Contact';

import DocumentSummaryReport from '../pages/Reports/DocumentSummary/DocumentSummaryReport';
import TotalTaxAmountReport from '../pages/Reports/TotalTaxAmount/TotalTaxAmountReport';

export default function RouterApp({ isDarkMode, toggleTheme }) {
    return (
        <BrowserRouter basename=''>
            <Routes>
                {/* Redirect the root path '/' to '/dashboard' */}
                <Route path="/" element={<RequireNoAuth><Navigate to="/login"/></RequireNoAuth>} />

                <Route path='/login' >
                    <Route index element={<RequireNoAuth><Login /></RequireNoAuth>} />
                </Route>

                <Route path='/changepassword' >
                    <Route index element={<RequireNoAuth><ChangePassword /></RequireNoAuth>} />
                </Route>

                <Route path='/resetpassword' >
                    <Route index element={<RequireNoAuth><ResetPassword /></RequireNoAuth>} />
                </Route>

                <Route path='/firsttimeresetpassword/:tokenId?' >
                    <Route index element={<RequireNoAuth><FirstTimeResetPassword /></RequireNoAuth>} />
                </Route>
                
                
                {/* Define the dashboard route */}
                <Route path='/dashboard' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route index element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><Dashboard /></RequireAuth>} />
                </Route>

                <Route path='/profile' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route index element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><Profile /></RequireAuth>} />
                </Route>
                <Route path='/company-profile' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route index element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><CompanyProfile /></RequireAuth>} />
                </Route>

                <Route path='/contact' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route index element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><Contact /></RequireAuth>} />
                </Route>

                {/* Define the masterdata route */}
                <Route path='/businessentity' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='Groups' element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><Groups /></RequireAuth>} />
                </Route>

                <Route path='/businessentity' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='Company' element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><Company /></RequireAuth>} />
                </Route>

                <Route path='/masterdata' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='TradingPartners' element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><TradingPartners /></RequireAuth>} />
                </Route>

                <Route path='/administration' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='Users' element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><Users /></RequireAuth>} />
                </Route>

                <Route path='/templates' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='Templates' element={<RequireAuth allowedRoles={['System Admin']}><Templates /></RequireAuth>} />
                </Route>

                <Route path='/documentupload' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='AccountReceivable' element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><AccountReceivable /></RequireAuth>} />
                </Route>
                <Route path='/documentupload' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='AccountPayable' element={<RequireAuth allowedRoles={['System Admin','Company Admin']}><AccountPayable /></RequireAuth>} />
                </Route>
                <Route path='/documentupload/AccountReceivable' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='Upload' element={<Upload />} />
                </Route>
                <Route path='/documentupload/AccountPayable' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='UploadPayable' element={<UploadPayable />} />
                </Route>
                <Route path='/reports' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='DocumentSummaryReport' element={<DocumentSummaryReport />} />
                </Route>
                <Route path='/reports' element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path='TotalTaxAmountReport' element={<TotalTaxAmountReport />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}
